import { render, staticRenderFns } from "./GuppyChatSidebarSetting.vue?vue&type=template&id=2602e05e&scoped=true&"
import script from "./GuppyChatSidebarSetting.vue?vue&type=script&lang=js&"
export * from "./GuppyChatSidebarSetting.vue?vue&type=script&lang=js&"
import style0 from "./GuppyChatSidebarSetting.vue?vue&type=style&index=0&id=2602e05e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2602e05e",
  null
  
)

export default component.exports